import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Select, DatePicker, Space, Form } from 'antd'
import Modal from "antd/lib/modal/Modal"
import TextArea from "antd/lib/input/TextArea"
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from '../../tool/axios'
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import { formItemLayout, tailLayout } from '../../js/globalParam'
import moment from 'moment';
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    salary_actual_id: string | undefined
    store_id: string | undefined
    nursing_name: string | undefined
    nursing_phone: string | undefined
    star_level_id: string | undefined
    effectiveDay: any
    effective_start_date: string | undefined
    effective_end_date: string | undefined
    is_effective: number | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: boolean
}

type empRecord = {
    employee_id: string
    user_name: string
}

type starLevelRecord = {
    star_level_id: string
    star_level_name: string
}

type salaryStandardRecord = {
    salary_standard_id: string
    star_level_name: string
    base_salary: number
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        salary_actual_id: undefined,
        store_id: undefined,
        nursing_name: undefined,
        nursing_phone: undefined,
        star_level_id: undefined,
        effectiveDay: null,
        effective_start_date: undefined,
        effective_end_date: undefined,
        is_effective: undefined
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [loading, setLoading] = useState<boolean>(false)
    const [data, setData] = useState<any>([])

    const [form] = Form.useForm()
    const [recordId, setRecordId] = useState<string>('')

    const [showType, setShowType] = useState<string>('')
    const [showVisible, setShowVisible] = useState<boolean>(false)

    const [empList, setEmpList] = useState<empRecord[]>([])
    const [starLevelList, setStarLevelList] = useState<starLevelRecord[]>([])
    const [salaryStandardList, setSalaryStandardList] = useState<salaryStandardRecord[]>([])

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        // 查询标准星级列表
        baseAxiosNoInfo.get("/yuesao_center/global/star_level_list", {

        }).then((res: any) => {
            res && setStarLevelList(res)
        })

        // 查询标准薪酬列表
        baseAxiosNoInfo.get("/yuesao_center/global/salary_standard_list", {

        }).then((res: any) => {
            res && setSalaryStandardList(res)
        })

        fetch({ pagination, fetchOtherParams })
    }, [pagination.current, pagination.pageSize])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleDate = (param: any, attr: string, realDateParams: string[]) => {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

            delete param[attr]
        }
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current
        p.pageSize = antPagination.pageSize

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }
        handleDate(params, 'effectiveDay', ['effective_start_date', 'effective_end_date'])

        axiosTable.get('/yuesao_center/manage/salary_actual/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const handleAddOrMod = (value: string) => {
        if (value) {
            setShowType('mod')

        } else {
            form.setFieldsValue({
                store_id: '',
                nursing_id: '',
                salary_standard_id: '',
                base_salary: '',
                actual_trusteeship_salary: '',
                actual_one_on_one_salary: '',
                actual_residence_salary: '',
                effective_start_date: '',
                effective_end_date: '',
                is_effective: '',
                adjustment_reason: ''
            })

            setShowType('add')
        }

        setRecordId(value)
        setShowVisible(true)
    }

    const confirmAddOrMod = (value: any) => {
        let id = recordId
        let url = id ? '/yuesao_center/manage/salary_actual/update' : '/yuesao_center/manage/salary_actual/add'

        let postData: any = {}

        if (id) {
            postData = {
                salary_actual_id: id,
                nursing_id: value.nursing_id,
                salary_standard_id: value.salary_standard_id,
                actual_trusteeship_salary: value.actual_trusteeship_salary,
                actual_one_on_one_salary: value.actual_one_on_one_salary,
                actual_residence_salary: value.actual_residence_salary,
                effective_start_date: moment(value.effective_start_date).format('YYYY-MM-DD'),
                effective_end_date: moment(value.effective_end_date).format('YYYY-MM-DD'),
                is_effective: value.is_effective,
                adjustment_reason: value.adjustment_reason
            }

        } else {
            postData = {
                nursing_id: value.nursing_id,
                salary_standard_id: value.salary_standard_id,
                actual_trusteeship_salary: value.actual_trusteeship_salary,
                actual_one_on_one_salary: value.actual_one_on_one_salary,
                actual_residence_salary: value.actual_residence_salary,
                effective_start_date: value.effective_start_date.format('YYYY-MM-DD'),
                effective_end_date: value.effective_end_date.format('YYYY-MM-DD'),
                is_effective: value.is_effective,
                adjustment_reason: value.adjustment_reason
            }
        }

        baseAxiosComplete.post(url, postData).then((res: any) => {
            if (res.status === 0) {
                let p: any = { ...pagination }
                p.current = 1

                setPagination(p)
                fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })

                setShowVisible(false)
            }
        })
    }

    return (<div className="common-page">
        {/* 月嫂中心 -> 月嫂管理 -> 月嫂薪酬管理 */}
        <BreadCrumb position={['月嫂中心', '月嫂薪酬管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores placeholder="门店" value={fetchOtherParams.store_id} onChange={(value: string) => { handleChange(value, 'store_id') }} />
                </div>

                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="员工名称" value={fetchOtherParams.nursing_name} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'nursing_name') }} />
                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="员工手机号" value={fetchOtherParams.nursing_phone} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'nursing_phone') }} />

                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="标准星级" value={fetchOtherParams.star_level_id} onChange={(v: string) => { handleChange(v, 'star_level_id') }}>
                    {starLevelList.map((el: any) => (<Option value={el.star_level_id} key={el.star_level_id}>{el.star_level_name}</Option>))}
                </Select>

                <RangePicker
                    className="fl"
                    style={{ marginRight: 8, marginBottom: 12, width: 250 }}
                    placeholder={["生效开始日期", "生效结束日期"]}
                    value={fetchOtherParams.effectiveDay}
                    onChange={(v: any) => { handleChange(v, 'effectiveDay') }}
                />
                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="是否有效" value={fetchOtherParams.is_effective} onChange={(value: number) => { handleChange(value, 'is_effective') }}  >
                    <Option value="1">是</Option>
                    <Option value="0">否</Option>
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch} >查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('添加') && <Button type="primary" style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { handleAddOrMod('') }}>添加</Button>}
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="salary_actual_id" pagination={pagination} onChange={handleTableChange}>
                <Column
                    fixed
                    title="操作"
                    key="action"
                    render={(text, record: any) => {
                        return (<Space size="middle">
                            {permission.includes('编辑') && <Button size="small" onClick={() => {
                                baseAxiosNoInfo('/yuesao_center/manage/salary_actual/detail', {
                                    params: {
                                        salary_actual_id: record.salary_actual_id
                                    }

                                }).then((res: any) => {
                                    res && form.setFieldsValue({
                                        nursing_id: res.nursing_id,
                                        nursing_name: res.nursing_name,
                                        salary_standard_id: res.salary_standard_id,
                                        actual_trusteeship_salary: res.actual_trusteeship_salary,
                                        actual_one_on_one_salary: res.actual_one_on_one_salary,
                                        actual_residence_salary: res.actual_residence_salary,
                                        effective_start_date: res.effective_start_date,
                                        effective_end_date: res.effective_end_date,
                                        is_effective: res.is_effective,
                                        adjustment_reason: res.adjustment_reason
                                    })
                                })

                                handleAddOrMod(record.salary_actual_id)
                            }} >编辑</Button>}
                        </Space>)
                    }}
                />

                <Column fixed title="门店名称" dataIndex="store_name" key="store_name" />
                <Column fixed title="员工名称" dataIndex="nursing_name" key="nursing_name" />
                <Column fixed title="员工手机号" dataIndex="nursing_phone" key="nursing_phone" />
                <Column fixed title="星级名称" dataIndex="star_level_name" key="star_level_name" />
                <Column title="基础薪资" dataIndex="base_salary" key="base_salary" />
                <Column title="实际托管薪资" dataIndex="actual_trusteeship_salary" key="actual_trusteeship_salary" />
                <Column title="实际一对一薪资" dataIndex="actual_one_on_one_salary" key="actual_one_on_one_salary" />
                <Column title="实际到府薪资" dataIndex="actual_residence_salary" key="actual_residence_salary" />
                <Column title="薪资调整" dataIndex="salary_adjustment" key="salary_adjustment" />
                <Column title="调整原因" dataIndex="adjustment_reason" key="adjustment_reason" />
                <Column title="是否有效" dataIndex="is_effective_desc" key="is_effective_desc" />
                <Column title="生效开始日期" dataIndex="effective_start_date" key="effective_start_date" />
                <Column title="生效结束日期" dataIndex="effective_end_date" key="effective_end_date" />
                <Column title="创建人" dataIndex="create_user_name" key="create_user_name" />
                <Column title="创建时间" dataIndex="create_time" key="create_time" />
                <Column title="更新人" dataIndex="update_user_name" key="update_user_name" />
                <Column title="更新时间" dataIndex="update_time" key="update_time" />
            </Table>
        </div>

        {/* 月嫂中心 -> 月嫂管理 -> 月嫂薪酬管理 -> 新增或编辑 */}
        <Modal title={showType == "add" ? "新增月嫂薪酬" : "编辑月嫂薪酬"} visible={showVisible} footer={false} width="500px" onCancel={() => { setShowVisible(false) }}>
            <Form {...formItemLayout} name="validate_other" form={form} onFinish={confirmAddOrMod} >
                {showType == "add" && (
                    <Form.Item label="门店" name="store_id" rules={[{ required: true, message: '必须选择门店' }]} >
                        <SelectStores onChange={((v: any) => {
                            // 查询该门店下的员工列表
                            baseAxiosNoInfo('/global/employee_list_by_position', {
                                params: {
                                    department_id: v,
                                    position_number: 21
                                }

                            }).then((res: any) => {
                                res && setEmpList(res)
                            })
                        })} />
                    </Form.Item>
                )}

                {showType == "add" && (
                    <Form.Item label="员工" name="nursing_id" rules={[{ required: true, message: '必须选择员工' }]} >
                        <Select virtual={false} showSearch filterOption={(input, option) => (option!.children as unknown as string).includes(input)}>
                            {empList.map((el: any) => (<Option value={el.employee_id} key={el.employee_id}>{el.user_name}</Option>))}
                        </Select>
                    </Form.Item>
                )}

                {showType != "add" && (
                    <Form.Item label="员工" name="nursing_name">
                        <Input readOnly />
                    </Form.Item>
                )}

                <Form.Item label="星级薪酬" name="salary_standard_id" rules={[{ required: true, message: '必须选择星级薪酬' }]} >
                    <Select virtual={false} showSearch filterOption={(input, option) => (option!.children as unknown as string).includes(input)}>
                        {salaryStandardList.map((el: any) => (<Option value={el.salary_standard_id} key={el.salary_standard_id}>{el.star_level_name}</Option>))}
                    </Select>
                </Form.Item>

                <Form.Item label="托管薪资" name="actual_trusteeship_salary" rules={[{ required: true, message: '必须填写托管薪资' }]} >
                    <Input type="number" placeholder="" />
                </Form.Item>

                <Form.Item label="一对一薪资" name="actual_one_on_one_salary" rules={[{ required: true, message: '必须填写一对一薪资' }]} >
                    <Input type="number" placeholder="" />
                </Form.Item>

                <Form.Item label="到府薪资" name="actual_residence_salary" rules={[{ required: true, message: '必须填写到府薪资' }]} >
                    <Input type="number" placeholder="" />
                </Form.Item>

                <Form.Item label="生效开始日期" name="effective_start_date" rules={[{ required: true, message: '必须选择生效开始日期' }]} getValueProps={(value) => ({ value: value ? moment(value) : null })}>
                    <DatePicker />
                </Form.Item>

                <Form.Item label="生效结束日期" name="effective_end_date" rules={[{ required: true, message: '必须选择生效结束日期' }]} getValueProps={(value) => ({ value: value ? moment(value) : null })}>
                    <DatePicker />
                </Form.Item>

                <Form.Item label="是否有效" name="is_effective" rules={[{ required: true, message: '必须选择是否有效' }]}>
                    <Select >
                        <Option value={1} key="1">是</Option>
                        <Option value={0} key="0">否</Option>
                    </Select>
                </Form.Item>

                <Form.Item label="调整原因" name="adjustment_reason" rules={[{ required: true, message: '必须填写调整原因' }]} >
                    <TextArea style={{ height: 150 }} />
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>
    </div>)
}